import CollapsibleItem from '../components/collapsible';

export default () => {
  if (!document.getElementsByClassName('accordion')) {
    return false;
  }

  new CollapsibleItem('.accordion__item');
};
